import { TopicStatus, TopicStatusChange } from "./Enums"
import { TagType } from "./Enums"

// Create a reverse lookup object
const StatusText = Object.keys(TopicStatus).reduce((obj, key) => {
    obj[TopicStatus[key]] = key
    return obj
}, {})
const TagTypeText = Object.keys(TagType).reduce((obj, key) => {
    obj[TagType[key]] = key
    return obj
}, {})

// Function to get the status string by its integer value
export const getStatusText = (statusInt) => {
    return StatusText[statusInt] || null
}
// Function to get the type string by its integer value
export const getTagTypeText = (typeInt) => {
    return TagTypeText[typeInt] || null
}

// Utility function to convert TopicStatus into dropdown options
export const topicStatusOptions = () => {
    return Object.entries(TopicStatus).map(([key, value]) => ({
        label: key,
        value: value,
        id: `${key}_${value}`
    }))
}

// Utility function to convert TopicStatusChange into dropdown options
export const topicStatusChangeOptions = () => {
    return Object.entries(TopicStatusChange).map(([key, value]) => ({
        label: key,
        value: value,
        id: `${key}_${value}`
    }))
}
